import { Input as AntInput } from 'antd';
import { FC, ReactChildren, ReactNode } from 'react';
import { InputProps, TextAreaProps } from 'antd/lib/input';
import { OTPProps } from 'antd/es/input/OTP';

type Props = {
  isTextArea?: boolean;
  isOtp?: boolean;
  isPassword?: boolean;
} & InputProps &
  TextAreaProps &
  OTPProps;

export const Input: FC<Props> = (props) => {
  const { type, ...rest } = props;

  const onChange = (e: any) => {
    if (type === 'number') {
      const value = e.target.value;
      if (isNaN(Number(value))) {
        if (rest.onChange) {
          rest.onChange({ ...e, target: { ...e.target, value: '' } });
        }
      } else {
        if (rest.onChange) {
          rest.onChange({ ...e, target: { ...e.target, value: parseFloat(value) } });
        }
      }
    } else {
      if (rest.onChange) {
        rest.onChange(e);
      }
    }
  };

  if (props.isTextArea) {
    return <AntInput.TextArea {...props} />;
  }
  if (props.isOtp) {
    return <AntInput.OTP {...props} />;
  }
  if (props.isPassword) {
    return <AntInput.Password {...props} />;
  }

  return <AntInput {...rest} onChange={onChange} />;
};

export default Input;
